export default "__VITE_ASSET__CLoRSDv2__"